import { useCartStoreOrNull } from 'stores/cartStore/CartStoreProvider'
import { useMobxSelector } from 'utils/mobx/useMobxSelector'
import { usePricing } from '../../../components/Pricing/PricingProvider'
import { getCartDiscount } from '../getCartDiscount'

export function useCartDiscount() {
  const { discounts, pricingData } = usePricing()
  const cartStore = useCartStoreOrNull()

  return useMobxSelector(() => {
    if (discounts.isLoading || pricingData.isLoading) return null

    return getCartDiscount({
      cartItems: cartStore?.cartItems ?? [],
      discounts: discounts.value,
      currency: pricingData.currency,
      pricingItems: pricingData.pricingItems,
    })
  }, [
    discounts.value,
    discounts.isLoading,
    pricingData.currency,
    pricingData.pricingItems,
    pricingData.isLoading,
  ])
}
